/* eslint-disable new-cap */
import {html} from 'lit';
import {ProductListing} from '../product-listing/product-listing';
import styles from './diamond-product-listing.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

class DiamondProductListing extends ProductListing {
	static get styles () {
		return [styles];
	}

	constructor () {
		super();
	}

	get compareActive () {
		return this.store?.diamond?.compareListActive;
	}

	renderResult (result) {
		return html`<rb-diamond-card .store="${this.store}" .result="${result}" class="o-layout__item diamond-product-listing--item"></rb-diamond-card>`;
	}

	renderResults () {
		return html`<div class="diamond-product-listing--items o-layout u-grids-1">
			${this.service?.store?.state?.results?.map(result => this.renderResult(result))}
		</div>`;
	}

	renderCompare () {
		return html`<div class="diamond-product-listing--items o-layout u-grids-1">
			${this.compareList?.map(result => this.renderResult(result))}
		</div>`;
	}

}

defineCustomElement('rb-diamond-product-listing', DiamondProductListing);
